export default __webpack_public_path__ + "static/person-with-laptop-c513aef89005db866da7b3fd23b30256.png";